import React from 'react'

/**
 * Título de sección para formularios
 * Usado en Settings, CRUD forms, etc.
 */
export function SectionTitle({ children, className = '' }) {
	return (
		<h4 className={`text-sm font-semibold text-gray-700 dark:text-gray-200 mb-4 mt-6 border-b border-gray-200 dark:border-gray-600 pb-2 ${className}`}>
			{children}
		</h4>
	)
}

/**
 * Label de campo con sublabel opcional
 * Usado para labels personalizados fuera de FormItem
 */
export function FieldLabel({ label, sublabel, required }) {
	return (
		<div className="mb-1">
			<label className="form-label">
				{label}
				{required && <span className="text-red-500 ml-1">*</span>}
			</label>
			{sublabel && (
				<p className="text-xs text-gray-500 dark:text-gray-400">{sublabel}</p>
			)}
		</div>
	)
}

export default { SectionTitle, FieldLabel }
